/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let AbstractDriver = exports.AbstractDriver = function () {
  /**
   * @param {*} context
   */
  function AbstractDriver(context) {
    _classCallCheck(this, AbstractDriver);

    this._context = context;
  }

  /**
   * @returns {*}
   */


  _createClass(AbstractDriver, [{
    key: 'log',


    /**
     * @param   {String} name
     * @param   {*} data
     * @param   {*} context
     *
     * @returns {Promise|*}
     */
    value: function log(name, data) {
      let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this._log(name, data, this.context.enrichEventContext(context));
    }

    /**
     * @param   {String} name
     * @param   {*} data
     * @param   {*} context
     *
     * @returns {Promise|*}
     *
     * @private
     */

  }, {
    key: '_printEvent',
    value: function _printEvent(name, data, context) {
      console.log('[EVENT]', name, '{DATA->', data, '}', '{CONTEXT->', context, '}');

      return Promise.resolve();
    }

    /**
     * @param   {String} name
     * @param   {*} data
     * @param   {Object} context
     *
     * @returns {Promise|*}
     *
     * @private
     */

  }, {
    key: '_log',
    value: function _log(name, data, context) {
      return Promise.reject(new Error(`Driver._log() not implemented!`));
    }
  }, {
    key: 'context',
    get: function get() {
      return this._context;
    }
  }]);

  return AbstractDriver;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Driver/AbstractDriver.js
// module id = 170
// module chunks = 0